<template>
  <v-card>
    <v-card-title>
      <v-list-item>
        <v-list-item-avatar size="60" class="mr-3">
          <v-img :src="logoUrl" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            My Submissions
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ pageName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-title>
    <v-card-subtitle>
      Submissions are stored on the device that submitted them (so you're still
      anonymous!)
    </v-card-subtitle>
    <v-card-actions>
        <v-row class="flex-row-reverse">
          <v-col cols="auto">
            <v-btn
              :href="submitAgainUrl"
              :style="
                `background-color:${buttonColor}!important; color: ${buttonTextColor}!important;`
              "
            >
              Submit again
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              v-if="hallOfFameEnabled"
              :href="hallOfFameUrl"
              :style="
                `background-color:${buttonColor}!important; color: ${buttonTextColor}!important;`
              "
            >
              {{ pageName }} Hall of Fame
            </v-btn>
          </v-col>
        </v-row>
    </v-card-actions>
  </v-card>
  <!-- <v-card id="submitted-wrapper">
    <div id="logo-text">
      <img id="logo" :src="logoUrl" />

      <div id="text-wrapper">
        <v-card-title>
          My Submissions
        </v-card-title>

        <v-card-subtitle>
          {{ pageName }}
        </v-card-subtitle>
      </div>
    </div>
    <div>
      Submissions are stored on the device that submitted them (so you're still
      anonymous!)
    </div>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        v-if="hallOfFameEnabled"
        :href="hallOfFameUrl"
        :style="
          `background-color:${buttonColor}!important; color: ${buttonTextColor}!important;`
        "
        >{{ pageName }} Hall of Fame</v-btn
      >
      <v-btn
        :href="submitAgainUrl"
        :style="
          `background-color:${buttonColor}!important; color: ${buttonTextColor}!important;`
        "
        >Submit again</v-btn
      >
    </v-card-actions>
  </v-card> -->
</template>
<script>
export default {
  name: "mySubmissionsHeader",

  props: {
    "logo-url": String,
    "page-name": String,
    "button-color": String,
    "button-text-color": String,
    "submit-again-url": String,
    "hall-of-fame-url": String,
    "hall-of-fame-enabled": String,
  },
};
</script>
<style scoped>
/*  content padding/margins need to be removed
    for mobile styling not to have a border
*/
html,
body {
  height: 100%;
}

#content {
  padding: 10px;
}

#main {
  display: flex;
  width: 90vw;
  justify-content: space-around;
}
</style>
